import _ from 'lodash';
import constants from '../consts';
import textUtils from './text-utils';

function replaceVariablesWithData(insightPart, insightData) {
  return insightPart.map(section => {
    if (section.type === constants.SectionNames.Amount) {
      const { variableName, ...otherFields } = section;
      return { ...otherFields, amount: _.get(insightData, variableName) };
    }
    if (section.type === constants.SectionNames.Transactions) {
      const { variableName, ...otherFields } = section;
      return { ...otherFields, transactions: _.get(insightData, variableName) };
    }
    if (section.type === constants.SectionNames.Text) {
      const { text, ...otherFields } = section;
      return { ...otherFields, text: textUtils.replaceVariablesInText(text, insightData) };
    }
    if (section.type === constants.SectionNames.Link) {
      const { text, url, ...otherFields } = section;
      return { ...otherFields, text: textUtils.replaceVariablesInText(text, insightData), url: textUtils.replaceVariablesInText(url, insightData) };
    }
    if (section.type === constants.SectionNames.LineBreak) {
      return section;
    }
    const { variableName, ...otherFields } = section;
    return { ...otherFields, data: _.get(insightData, variableName) };
  });
}

function getRequiredVariables(sections) {
  const sectionVariables = sections.flatMap(section => {
    switch (section.type) {
      case this.SectionNames.Text:
        // For text like "I might ${be} an ${insight}" returns ['be', 'insight']
        return textUtils.getVariableNamesFromText(section.text);
      case this.SectionNames.Link:
        return [...textUtils.getVariableNamesFromText(section.text), ...textUtils.getVariableNamesFromText(section.url)];
      case this.SectionNames.Amount:
      case this.SectionNames.Transactions:
        return [section.variableName];
      case this.SectionNames.LineBreak:
        return [];
      default:
        // assume this is the most useful default behaviour for new components
        return [section.variableName];
    }
  });
  return _.uniq(_.compact(sectionVariables)) || [];
}

export default {
  replaceVariablesWithData,
  getRequiredVariables,
};
